import { AxiosRequestConfig } from 'axios';
import store from '@/store';

export function requestInterceptor(config: AxiosRequestConfig): AxiosRequestConfig {
  const token = store?.state?.user?.accessToken;
  if (token) {
    config.headers = {
      ...config.headers,
      Authorization: `Bearer ${ token }`,
    };
  }
  return config;
}
